import { fetchAPI } from '../../api';
import { OrderStatus } from '../../types';
import { KybSave, Merchant } from './types';

export interface SubmitResponse {
  merchantId: OrderStatus;
  riskScore?: number;
}

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const submitAnswers = (
  email: string,
  merchant: Merchant,
  kyb: KybSave
) => {
  const newKyb = {
    ...kyb,
    onboardingDate: formatDate(new Date()),
    relatedPeople:
      kyb.relatedPeople &&
      kyb.relatedPeople.length > 0 &&
      kyb.relatedPeople[0].isPep
        ? kyb.relatedPeople.map((p) => ({
            ...p,
            dateOfBirth: formatDate(p.dateOfBirth),
          }))
        : undefined,
  };
  return fetchAPI<SubmitResponse>(`v1/merchant:initialize`, {
    method: 'POST',
    body: {
      email,
      merchant,
      kyb: newKyb,
    },
  });
};
